import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

//Ant
import { Row, Col, Button, Input, Spin } from "antd";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";

//Components
import NewPromotionModal from "./NewPromotionModal";

const PromotionsList = React.lazy(() => import("./PromotionsList"));
const { Search } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

class index extends Component {
  state = {
    newPromotionModalVisible: false,
    search: "",
    editedPromotionIndex: null,
  };

  setEditPromotion = (editedPromotionIndex) => {
    this.setState({ newPromotionModalVisible: true, editedPromotionIndex });
  };
  render() {
    const { permissions, loading, config, t } = this.props;
    const { newPromotionModalVisible, search, editedPromotionIndex } =
      this.state;

    return (
      <>
        {newPromotionModalVisible && (
          <NewPromotionModal
            visible={newPromotionModalVisible}
            editedPromotionIndex={editedPromotionIndex}
            onClose={() => {
              this.setState({
                newPromotionModalVisible: false,
                editedPromotionIndex: null,
              });
            }}
          />
        )}
        <div
          className="my-3"
          style={{
            display: "flow-root",
          }}
        >
          <Search
            style={{
              float: config.direction === "ltr" ? "left" : "right",
              maxWidth: 300,
            }}
            placeholder={t("Search for a promotion")}
            enterButton
            onChange={(e) => this.setState({ search: e.target.value })}
          />
          <Button
            disabled={!permissions.can_create_promotions}
            type="link"
            icon={<PlusOutlined style={{ position: "relative", top: -2 }} />}
            onClick={() => {
              this.setState({ newPromotionModalVisible: true });
            }}
            style={{ float: config.direction === "ltr" ? "right" : "left" }}
          >
            {t("New promotion")}
          </Button>
        </div>
        <div className="whiteSubContainer" style={{ paddingBottom: 40 }}>
          <Suspense
            fallback={
              <div className="mt-4 text-center">
                <Spin indicator={antIcon} />
              </div>
            }
          >
            {/*{!loading ? (*/}
            {/*  <PromotionsList*/}
            {/*    search={search}*/}
            {/*    setEditPromotion={this.setEditPromotion}*/}
            {/*  />*/}
            {/*) : (*/}
            {/*  <div className="mt-4 text-center">*/}
            {/*    <Spin indicator={antIcon} />*/}
            {/*  </div>*/}
            {/*)}*/}
            <PromotionsList
              loading={loading}
            search={search}
            setEditPromotion={this.setEditPromotion}
          />
          </Suspense>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    permissions: state.auth.permissions,
    loading: state.promotions.loadingPromotions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(index));
